require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-grcf-2-w-2-almaty-electric-public-transport.json") })
        }
      }, "path---en-us-project-grcf-2-w-2-almaty-electric-public-transport");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-grcf-2-w-2-almaty-electric-public-transport!./.cache/json/en-us-project-grcf-2-w-2-almaty-electric-public-transport.json
// module id = 511
// module chunks = 231608221292675